<script setup>

</script>

<template>
  <!-- page wrap -->
  <div class="section section--content">
    <div class="section__content">
      <!-- error -->
      <div class="page-error">
        <h1 class="page-error__title">404</h1>
        <p class="page-error__text">The page you are looking for not available!</p>
        <a href="index.html" class="page-error__btn">go back</a>

        <!-- design elements -->
        <span class="block-icon block-icon--purple">
					<i class="ti ti-error-404"></i>
				</span>
        <span class="screw screw--big-tr"></span>
        <span class="screw screw--big-bl"></span>
        <span class="screw screw--big-br"></span>
      </div>
      <!-- end error -->
    </div>

    <!-- animation background -->
    <div class="section__canvas section__canvas--full section__canvas--third" id="canvas3"></div>
  </div>
  <!-- end page wrap -->
</template>

<style scoped>

</style>
